import React, { useRef } from 'react';

import { useViewport } from 'utils/getViewport/getViewport';
import Tooltip from 'components/common/Tooltip/Tooltip';
import { Grid } from '@material-ui/core';
import { decodeHtml } from 'utils/htmlEncoderDecoder';
import MobileAssessmentNavBar from './MobileAssessmentNavBar/MobileAssessmentNavBar';
import { AssessmentNavBarIcons } from './AssessmentNavBarIcons/AssessmentNavBarIcons';
import { useTooltipTrigger } from '../../../../utils/getTooltipTrigger/getTooltipTrigger';
import './AssessmentNavBar.scss';

export function AssessmentNavBar(props) {
  const { sidebarView, assessmentName, onIconClick, assessmentCompanyName, identifier, filterVariables, activeUsers, productIdentifier } = props;

  const { isMobile } = useViewport();

  const companyNameRef = useRef();
  const assessmentNameRef = useRef();

  const showCompanyNameTooltip = useTooltipTrigger(companyNameRef);
  const showAssessmentNameTooltip = useTooltipTrigger(assessmentNameRef);
  let navBarHeading;

  if (productIdentifier === 'E4BU') {
    navBarHeading = `${decodeHtml(identifier)}`;
  } else {
    navBarHeading = `${decodeHtml(assessmentCompanyName)} | ${decodeHtml(identifier)}`;
  }

  return (
    <>
      {isMobile ? (
        <MobileAssessmentNavBar {...props} />
      ) : (
        <div className="assessment-nav-bar nav-bar">
          <Grid container spacing={0}>
            <Grid item xs={12} className="assessment-navbar-name">
              {}
              <Tooltip title={navBarHeading} disableHoverListener={!showCompanyNameTooltip}>
                <div className="name-prefix" ref={companyNameRef}>
                  {navBarHeading}
                </div>
              </Tooltip>
            </Grid>
            <Grid item xs={12} sm container className="assessment-navbar-name">
              <Grid item xs={10}>
                <Tooltip title={decodeHtml(assessmentName)} disableHoverListener={!showAssessmentNameTooltip}>
                  <div className="name assessment-name-width" ref={assessmentNameRef}>
                    {decodeHtml(assessmentName)}
                  </div>
                </Tooltip>
              </Grid>
              <Grid item xs={2}>
                {!isMobile && (
                  <AssessmentNavBarIcons
                    assessmentName={assessmentName}
                    sidebarView={sidebarView}
                    onIconClick={onIconClick}
                    filterVariables={filterVariables}
                    activeUsers={activeUsers}
                    productIdentifier={productIdentifier}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
}

export default AssessmentNavBar;
